import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import {
  Container,
  Typography,
  Grid,
  TextField,
  Button,
  Stack,
  Card,
  Divider,
  Paper,
  Input,
} from "@mui/material";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import SaveIcon from "@mui/icons-material/Save";
import AddIcon from "@mui/icons-material/Add";
import { useForm, Controller } from "react-hook-form";

const ViewEvent = () => {
  const { eventId } = useParams(); // Access the eventId from URL
  const [event, setEvent] = useState(null);
  const [viewEventDetailsData, setViewEventDetailsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [eventImage, setEventImage] = useState(null);

  useEffect(() => {
    const fetchEventData = async () => {
      try {
        const eventResponse = await axios.get(
          `https://cms-test.my-ogawa.com/backend/script/bodyfriend/event/get_event_details.php?id=${eventId}`
        );

        if (eventResponse.data.success && eventResponse.data.event) {
          setEvent(eventResponse.data.event);
          const imageUrl = eventResponse.data.event.image
            ? `https://cms-test.my-ogawa.com/backend/uploads/bodyfriend/eventImages/${eventResponse.data.event.image}`
            : null;
          setEventImage(imageUrl);
        } else {
          setError("Event not found.");
        }

        const eventDetailsResponse = await axios.get(
          `http://localhost/CMS/backend/script/bodyfriend/event/get_event_details.php?id=${eventId}`
        );
        if (
          eventDetailsResponse.data.success &&
          eventDetailsResponse.data.event_details
        ) {
          setViewEventDetailsData(eventDetailsResponse.data.event_details);
        }
      } catch (err) {
        setError("Error fetching event data.");
      } finally {
        setLoading(false);
      }
    };
    if (eventId) {
      fetchEventData();
    }
  }, [eventId]);

  const handleUpdateClick = () => {
    const updateUrl = `http://localhost:3000/bodyfriend-cms/update-event/${eventId}`;
    console.log("Navigating to URL:", updateUrl); // This will log the full URL
    window.location.href = updateUrl; // Use window.location.href for full URL navigation
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;
  if (!event) return <div>No event found.</div>;

  return (
    <Container sx={{ padding: 4 }}>
      <Typography variant="h4" fontWeight="bold" gutterBottom>
        View Event
      </Typography>
      <Card sx={{ p: 3, mb: 3 }}>
        <Typography variant="h6" fontWeight="bold">
          Event
        </Typography>
        <Divider sx={{ my: 2 }} />
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Event Name"
              fullWidth
              variant="outlined"
              value={event.name}
              disabled
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Start Date"
              fullWidth
              variant="outlined"
              value={event.start_date}
              disabled
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="End Date"
              fullWidth
              variant="outlined"
              value={event.end_date}
              disabled
            />
          </Grid>
          <Grid item xs={12}>
            {eventImage && (
              <img
                src={eventImage}
                alt="Event"
                height="200"
                style={{ marginTop: 8 }}
              />
            )}
          </Grid>
        </Grid>
      </Card>

      <Typography variant="h6" fontWeight="bold" gutterBottom>
        Event Details
      </Typography>
      {viewEventDetailsData.length > 0 ? (
        viewEventDetailsData.map((detail, index) => (
          <Paper variant="outlined" sx={{ p: 2, mb: 2 }} key={index}>
            {detail.type === "description" && (
              <Typography>{detail.content}</Typography>
            )}
            {detail.type === "image" && (
              <img src={detail.content} alt="Event Detail" height="120" />
            )}
          </Paper>
        ))
      ) : (
        <Typography>No event details available.</Typography>
      )}

      <Button variant="contained" color="primary" onClick={handleUpdateClick}>
        Edit Event
      </Button>
    </Container>
  );
};

export default ViewEvent;
